import React, { Component } from "react";
import { GoogleLogin } from '@react-oauth/google';
import { GetText, MD5, RandomNumber } from '../config/helper';
import { Container, Card, Form, Button, Modal } from "react-bootstrap";
import { Tooltip } from 'react-tooltip';
import { FaCircleInfo, FaCircleCheck, FaTriangleExclamation, FaRegCircleQuestion } from "react-icons/fa6";
import '../config/global';
import TagHeaders from '../inc/Headers';

const authKey = global.config.kindcode.training[0]+global.config.authBearerKey;
const authKey2= global.config.kindcode.training[6]+global.config.authBearerKey;

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
	  user_id: '',
	  fullname: '',
	  email: '',
	  phone: '',
	  username: '',
	  password: '',
	  password_confirm: '',
	  otp: '',
	  expiry: '',
	  language: localStorage.getItem('language'),
      redirect: '',
	  tab_form: '',
	  form_error: [],
	  member_profile: {},
	  referral_code: '',
	  modal_show_refcode: false
    }
	this.inputReferralCode = this.inputReferralCode.bind(this);
	this.inputFullname = this.inputFullname.bind(this);
    this.inputEmail = this.inputEmail.bind(this);
    this.inputPhone = this.inputPhone.bind(this);
    this.inputUsername = this.inputUsername.bind(this);
    this.inputPassword = this.inputPassword.bind(this);
    this.inputPasswordConfirm = this.inputPasswordConfirm.bind(this);
    this.inputOtp = this.inputOtp.bind(this);
    this.login = this.login.bind(this);
	this.register = this.register.bind(this);
    this.activate = this.activate.bind(this);
    this.forgot = this.forgot.bind(this);
    this.reset = this.reset.bind(this);
    this.confirmOtp = this.confirmOtp.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
	this.updateReferralCode = this.updateReferralCode.bind(this);
  }

  
  getLanguage() {
	let language = 'English';
	fetch('https://ipapi.co/json/', {
			method: "GET",
	}).then((response) => {
		if (response.status === 200) {
			return response.json();
		} else {
			console.log("Something happened wrong");
		}
	}).then((resultJson) => {
		if (resultJson.country_name === 'Indonesia') { language = 'Indonesian'; } 
		else { language = 'English'; }

		this.setState({
			language: language
		});
	}).catch(err => { 
		this.setState({
			language: language
		}); 
	}); 
  }

  setTab() {
	var redirect = -1, res_redirect = "";
	var token="", res_token = "", docid="", expiry=0;
	var current = new Date().getTime();
	var url = window.location.href;

	var params = url.split('?'); 
	var tabKey = params[0].substring(params[0].lastIndexOf('/')+ 1);
	
	if(params.length > 1) { 
		if(params[1].indexOf('redirect',0) > -1) { 
			res_redirect = decodeURIComponent(params[1].toString().replace("redirect=","")); 
			this.setState({
				tab_form: 'login',
				redirect: res_redirect
			});
		} else if(params[1].indexOf('token',0) > -1) { 

			token = params[1].toString().replace("token=",""); 
			docid = token.substring(1,3) + token.substring(5,9) + token.substring(12,17) + token.substring(23,28) + token.substring(token.length - 4);
		
			if(tabKey === "activation") { 
				this.setState({
					tab_form: tabKey
				});		
				this.activate(docid,tabKey);
			} else  if(tabKey === "reset") { 
				var key = token.substring(0,1);
				var hash = token.substring(3,5) + token.substring(9,12) + token.substring(17,23) + token.substring(28,29);
				var expiry = Math.floor(hash / key * 100).toString().substring(0,13);
				var current = new Date().getTime();
		
				this.setState({
					user_id: docid,
					expiry: expiry,
					tab_form: (parseInt(expiry) < parseInt(current) ? 'reset-expired' : 'reset')
				});
			} else {
				if(tabKey === "") { tabKey = "login"; } 
				this.setState({
					tab_form: tabKey
				});
			}
		} else {
			if(tabKey === "") { tabKey = "login"; } 
			this.setState({
				tab_form: tabKey
			});
		}
	} else {
		if(tabKey === "") { tabKey = "login"; } 
		this.setState({
			tab_form: tabKey
		});
	}
	
  }

  inputFullname(event) {
	var error = [];
	if (event.target.value.length > 80) {
		document.getElementById('submit').setAttribute('disabled', 'true');
		error.push('fullname_max');
	} else {
		document.getElementById('submit').removeAttribute('disabled');
	}
	this.setState({ 
		fullname: event.target.value,
		form_error: error
	});
  }
  inputEmail(event) {
    this.setState({ 
      email: event.target.value,
      form_error: []
    });
  }

  inputPhone(event) {
    this.setState({ 
      phone: event.target.value,
      form_error: []
    });
  }
  inputUsername(event) {
    this.setState({ 
      username: event.target.value,
      form_error: []
    });
  }

  inputPassword(event) {
    this.setState({ 
      password: event.target.value,
      form_error: []
    });
  }
  inputPasswordConfirm(event) {		
    var error = [];
    if (this.state.password !== event.target.value) {
      document.getElementById('submit').setAttribute('disabled', 'true');
      error.push('password_same');
      this.setState({
        form_error: error
      });
    } else {
      document.getElementById('submit').removeAttribute('disabled');
      this.setState({
        form_error: []
      });
    }
    this.setState({ 
      password_confirm: event.target.value
    });
  }

  inputOtp(event) {
    this.setState({ 
      otp: event.target.value,
      form_error: []
    });
  }
  inputReferralCode(event) {
    this.setState({ 
      referral_code: event.target.value.toUpperCase(),
      form_error: []
    });
  }
  
  error = (response) => {
	console.log("Something happened wrong");
	document.getElementsByClassName("err-area")[0].style.display = "block";
  }

  generateSession(data) {
	var dataReceived = JSON.parse(data);
	
	localStorage.setItem("logged_in", global.config.randomLoginKey);
	localStorage.setItem("doc_id", dataReceived.doc_id);
	localStorage.setItem("name", dataReceived.member_name);
	localStorage.setItem("email", dataReceived.member_email);
	localStorage.setItem("status", dataReceived.member_plan);
	localStorage.setItem("ulvl", dataReceived.user_level);
	localStorage.setItem("avatar", dataReceived.member_picture);
	localStorage.setItem("language", dataReceived.member_language);
	localStorage.setItem("token", dataReceived.uniq_token);
	localStorage.setItem("mcomp", dataReceived.member_company);
	localStorage.setItem("spage", dataReceived.special_page);
	
	window.location.href = "/" + this.state.redirect;
  }
  skipReferralCode() {
	this.setState({ 
		modal_show_refcode: false,
	});
	this.generateSession(JSON.stringify(this.state.member_profile));
  }
  submitProfile(dataProfile) {
	var dataText = '{';
    dataText += '"memberdoc_id":"'+ dataProfile.doc_id +'","member_referral_code":"'+dataProfile.referal_code+'","form_id": "update-profile"';
    if(dataProfile.member_company !== undefined && dataProfile.member_company !== "") {
      dataText += ',"member_company": "'+dataProfile.member_company+'"'; 
    }
    dataText += '}';
	var data = JSON.parse(dataText);
    var authKey_P = authKey+dataProfile.doc_id
    fetch(global.config.urlLink+"/trainingupdateprofile", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey_P
      }, 
      body : JSON.stringify(data)
    })
    .then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong.');
      }
    }).then(resultJson => {
		this.generateSession(JSON.stringify(dataProfile));
    });


  }
  updateReferralCode(event) {
    event.preventDefault();
    document.getElementById('submit_refcode').innerText = 'Loading...';
    document.getElementById('submit_refcode').setAttribute('disabled', 'true');

    var error = [];
	if(this.textInputReferralCode.value === "") {
		error.push('referral_code');	
	}
	if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit_refcode').innerText = GetText() ? "Submit" : "Submit";
      document.getElementById('submit_refcode').removeAttribute('disabled');
      return;
    } else {
		  var dataSend = {
			"referal_code": this.textInputReferralCode.value,
			"form_id": "check-referalcode"
		  }
		  fetch(global.config.urlLink+"/cekrefcode", {
			method: 'POST',
			headers: {
			  'Accept': 'application/json',
			  'Content-Type': 'application/json',
			  'Access-Control-Allow-Origin': '*',
			  'Authorization': authKey2
			}, 
			body : JSON.stringify(dataSend)
		  })
		  .then(response => {
			if(response.status === 200) {
			  return response.json();
			} else {
			  console.log('Something happened wrong.');
			}
		  }).then(resultJson => {
			if(resultJson.status === "200" && resultJson.values.length > 0) {
			  var company_domain = ""; if(resultJson.values[0].content.companyDomain !== undefined && resultJson.values[0].content.companyDomain !== "") { company_domain = resultJson.values[0].content.companyDomain; };
			  var member_profile = this.state.member_profile;
			  member_profile.referal_code = this.textInputReferralCode.value;
			  
			  if(member_profile.member_company !== undefined && member_profile.member_company !== "") {
				if(company_domain.trim().toLowerCase() === member_profile.member_company.trim().toLowerCase()) { 
				  member_profile.member_company = company_domain;
				  this.submitProfile(member_profile); 
				} else { 
				  error.push('referral_code_3');
				  this.setState({
					form_error: error
				  });
				  document.getElementById('submit_refcode').innerText = 'Submit';
				  document.getElementById('submit_refcode').removeAttribute('disabled');
				  return;
				}
			  } else {
				member_profile.member_company = company_domain;
				this.submitProfile(member_profile); 
			  }
			} else {
			  error.push('referral_code_2');
			  this.setState({
				form_error: error
			  });
			  document.getElementById('submit_refcode').innerText = 'Submit';
			  document.getElementById('submit_refcode').removeAttribute('disabled');
			  return;
			}
		  });
	}
		
  }

  login(event) {
	event.preventDefault();
    document.getElementById('submit').innerText = 'Loading...';
    document.getElementById('submit').setAttribute('disabled', 'true');

    var error = [];
    if (!(this.state.username)) {
      error.push('username');
    }
    if (!(this.state.password)) {
      error.push('password');
    }
    if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit').innerText = 'Login';
      document.getElementById('submit').removeAttribute('disabled');
      return;
    } else {
	
		var dataText = '{"user_email":"' + this.state.username + '", "user_username":"' + this.state.username + '","user_password":"' + MD5(this.state.password) + '","user_language":"' + this.state.language + '","form_id":"login-email"}';
		var dataSend = JSON.parse(dataText);

		fetch(global.config.urlLink+"/ceklogin", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			var error = [];
			if (resultJson.values[0].error) {
				error.push('invalid');
				this.setState({
					form_error: error
				});
				document.getElementById('submit').innerText = 'Login';
				document.getElementById('submit').removeAttribute('disabled');
				if(resultJson.values[0].error === "OTP required") { 
					localStorage.setItem("doc_id", resultJson.values[0].data.docid);
					localStorage.setItem("email", resultJson.values[0].data.email);
					window.location.href = "/login/confirm-otp";
				}
			} else if (resultJson.values[0].docid) {
				var member = resultJson.values[0];
				var picavatar = "";
				var setlangz = this.state.language;
				var companyDomain = "";
				if (member.memberPicture !== undefined && member.memberPicture !== "") { picavatar = member.memberPicture; }
				if(member.memberLanguage !== undefined && member.memberLanguage !== "undefined" && member.memberLanguage !== "") { setlangz = member.memberLanguage; }
				if(member.companyName !== undefined && member.companyName !== "undefined" && member.companyName !== "") { companyDomain = member.companyName; }

				var dataSendUser = {
					"doc_id": member.docid,
					"member_name": member.memberName,
					"member_email": member.memberEmail,
					"member_plan": member.memberPlan,
					"user_level": member.userLevel,
					"member_picture": picavatar,
					"member_language": setlangz,
					"uniq_token": member.uniqueToken,
					"member_company": companyDomain
				}
				this.generateSession(JSON.stringify(dataSendUser));
			}
			
		})
		.catch((err) => {
			alert(err);
			window.location.href = "/" + this.state.redirect;
		});
		
	} 
  }

  cekLogin(dataText) {
	var dataJson = JSON.parse(dataText);
	fetch(global.config.urlLink+"/ceklogin", {
		method: "POST",
		headers: {
			'Accept': "application/json",
			'Content-Type': "application/json",
			'Access-Control-Allow-Origin': "*",
			'Authorization': authKey
		},
		body: JSON.stringify(dataJson),
	})
	.then((response) => {
		if (response.status === 200) {
			return response.json();
		} else {
			console.log("Something happened wrong");
		}
	})
	.then((resultJson) => {
		var udocid = dataJson.docid;
		var ufullname = dataJson.user_fullname;
		var uemailname = dataJson.user_email;
		var picavatar = dataJson.user_picture;
		var setlangz = this.state.language;
		var mplan = global.config.memberPlan[0];
		var ulevel = "User";
		var uniqueToken = "", companyDomain="", referralCode="", specialPage=[];
		if (resultJson.values[0].docid) {
			var member = resultJson.values[0];
			if(member.docid !== undefined && member.docid !== "") { udocid = member.docid; }
			if(member.memberPicture !== undefined && member.memberPicture !== "") { picavatar = member.memberPicture; }
			if(member.memberName !== undefined && member.memberName !== "") { ufullname = member.memberName; }
			if(member.memberEmail !== undefined && member.memberEmail !== "") { uemailname = member.memberEmail; }
			if(member.memberLanguage !== undefined && member.memberLanguage !== "undefined" && member.memberLanguage !== "") { setlangz = member.memberLanguage; }
			if(member.memberPlan !== undefined && member.memberPlan !== "") { mplan = member.memberPlan; }
			if(member.userLevel !== undefined && member.userLevel !== "") { ulevel = member.userLevel; }
			if(member.uniqueToken !== undefined && member.uniqueToken !== "") { uniqueToken = member.uniqueToken; }
			if(member.companyName !== undefined && member.companyName !== "") { companyDomain = member.companyName; }
			if(member.refCode !== undefined && member.refCode !== "") { referralCode = member.refCode; }
			if(member.spages !== undefined && member.spages.length > 0) { 
				member.spages.forEach((dataspage, pg) => {
					specialPage.push(dataspage.subcontent);
				});
			}
		}
		
		var dataSendUser = {
			"doc_id": udocid,
			"member_name": ufullname,
			"member_email": uemailname,
			"member_plan": mplan,
			"user_level": ulevel,
			"member_picture": picavatar,
			"member_language": setlangz,
			"uniq_token": uniqueToken,
			"member_company": companyDomain,
			"special_page": JSON.stringify(specialPage)
		}
		if(referralCode !== undefined && referralCode !== "") {
			this.generateSession(JSON.stringify(dataSendUser));
		} else {
			if(global.config.referralCodeStatus === 1) {
				this.setState({
					member_profile: dataSendUser,
					modal_show_refcode: true
				});		
			} else {
				this.generateSession(JSON.stringify(dataSendUser));
			}
		}
		
		

	})
	.catch((err) => {
		alert(err);
		window.location.href = "/" + this.state.redirect;
	});
	
  }
  successLogin = (response) => {
	document.getElementsByClassName("err-area")[0].style.display = "none";
	var dataSend = response;
	fetch(global.config.urlLink+"/getggprofile", {
		method: 'POST',
		headers: {
			'Accept': "application/json",
			'Content-Type': "application/json",
			'Access-Control-Allow-Origin': "*",
			'Authorization': authKey
		},
		body: JSON.stringify(dataSend),
	  })
	  .then(response => {
		if(response.status === 200) {  return response.json(); } 
		else { console.log('Something happened wrong.'); }
	  })
	  .then(resJson => {
		var dataTextSend = '{"user_email":"' + resJson.values.email + '","user_id":"' + resJson.values.sub + '","user_fullname":"' + resJson.values.name + '","user_picture":"' + resJson.values.picture + '","user_language":"' + this.state.language + '"}';
		this.cekLogin(dataTextSend);
	  });
  }

  register(event) {
    event.preventDefault();
    document.getElementById('submit').innerText = 'Loading...';
    document.getElementById('submit').setAttribute('disabled', 'true');

    var error = [];
    if (!(this.state.fullname)) {
      error.push('fullname');
    }
    if (this.state.fullname.length > 80) {
      error.push('fullname_max');
    }
    if (!(this.state.email)) {
      error.push('email');
    }
    if (!(this.state.password)) {
      error.push('password');
    }
    if (!(this.state.password_confirm)) {
      error.push('password_confirm');
    }
		if (this.state.password !== this.state.password_confirm) {
      error.push('password_same');
    }
    if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit').innerText = GetText() ? "Daftar" : "Register";
      document.getElementById('submit').removeAttribute('disabled');
      return;
    }
	
		var dataText = '{"user_id":"'+RandomNumber(21)+'","user_fullname":"' + this.state.fullname + '","user_email":"' + this.state.email + '","user_phone":"' + this.state.phone + '","user_password":"' + MD5(this.state.password) + '","user_language":"' + this.state.language + '","form_id":"register"}';
		var dataSend = JSON.parse(dataText);
		fetch(global.config.urlLink+"/register", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			var error = [];
			if (resultJson.values[0].error) {
				error.push('inuse');
				this.setState({
					form_error: error
				});
				document.getElementById('submit').innerText = GetText() ? "Daftar" : "Register";
				document.getElementById('submit').removeAttribute('disabled');
			} else {
				document.getElementById("register-page").style.display = "none";
				document.getElementById("register-message").style.display = "flex";
			}
		})
		.catch((err) => {
			alert(err);
			window.location.href = "/" + this.state.redirect;
		});
		
  }

  forgot(event) {
    event.preventDefault();
    document.getElementById('submit').innerText = 'Loading...';
    document.getElementById('submit').setAttribute('disabled', 'true');

    var error = [];
    if (!(this.state.email)) {
      error.push('email');
    }
    if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit').innerText = GetText() ? "Kirim Link" : "Send Link";
      document.getElementById('submit').removeAttribute('disabled');
      return;
    }
	
		var dataText = '{"user_email":"' + this.state.email + '","user_id":"' + this.state.user_id + '","form_id":"forgot"}';
		var dataSend = JSON.parse(dataText);
		
		fetch(global.config.urlLink+"/forgot", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			var error = [];
			if (resultJson.values[0].error) {
				if(resultJson.values[0].error === "account is deactive") {
					error.push('account is deactive');
					this.setState({
						form_error: error
					});
				} else {
					error.push('invalid');
					this.setState({
						form_error: error
					});
				}
				
				document.getElementById('submit').innerText = GetText() ? "Kirim Link" : "Send Link";
				document.getElementById('submit').removeAttribute('disabled');
			} else {
				document.getElementById("forgot-page").style.display = "none";
				document.getElementById("forgot-message").style.display = "flex";		
			}
		})
		.catch((err) => {
			alert(err);
			window.location.href = "/" + this.state.redirect;
		});
		
  }

  reset(event) {
    event.preventDefault();
    document.getElementById('submit').innerText = 'Loading...';
    document.getElementById('submit').setAttribute('disabled', 'true');

    var error = [];
    if (!(this.state.password)) {
      error.push('password');
    }
    if (!(this.state.password_confirm)) {
      error.push('password_confirm');
    }
		if (this.state.password !== this.state.password_confirm) {
      error.push('password_same');
    }
    if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit').innerText = GetText() ? "Simpan" : "Save";
      document.getElementById('submit').removeAttribute('disabled');
      return;
    }
		
		var dataText = '{"user_id":"' + this.state.user_id + '","user_password":"' + MD5(this.state.password) + '","form_id":"reset"}';
		var dataSend = JSON.parse(dataText);
		fetch(global.config.urlLink+"/passwordreset", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			if (resultJson.values[0].error) {
				var error = [];
				error.push('invalid');
				this.setState({
					form_error: error
				});
				document.getElementById('submit').innerText = (GetText() ? 'Simpan' : 'Save');
				document.getElementById('submit').removeAttribute('disabled');
			} else {
				document.getElementById("reset-page").style.display = "none";
				document.getElementById("reset-message").style.display = "flex";				
			}
		})
		.catch((err) => {
			alert(err);
			window.location.href = "/" + this.state.redirect;
		});
		
	}

  confirmOtp(event) {
    event.preventDefault();
    document.getElementById('submit').innerText = 'Loading...';
    document.getElementById('submit').setAttribute('disabled', 'true');

    var error = [];
    if (!(this.state.otp)) {
      error.push('otp');
    }
    if (error.length) {
      this.setState({
        form_error: error
      });
      document.getElementById('submit').innerText = GetText() ? "Kirim" : "Submit";
      document.getElementById('submit').removeAttribute('disabled');
      return;
    }
		
		var dataText = '{"otpcode":"' + this.state.otp + '","user_id":"'+localStorage.getItem('doc_id')+'","email":"'+localStorage.getItem('doc_id')+'","form_id":"confirm-otp"}';
		var dataSend = JSON.parse(dataText);

		fetch(global.config.urlLink+"/ceklogin", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			document.getElementById('submit').innerText = (GetText() ? 'Kirim' : 'Submit');
			document.getElementById('submit').removeAttribute('disabled');
			if (resultJson.values[0].error) {
				var error = [];
				error.push('invalid');
				this.setState({
					form_error: error
				});
			} else {
				var member = resultJson.values[0];
				var picavatar = "";
				var setlangz = this.state.language;
				var companyDomain = "";
				if (member.memberPicture !== undefined && member.memberPicture !== "") { picavatar = member.memberPicture; }
				if(member.memberLanguage !== undefined && member.memberLanguage !== "undefined" && member.memberLanguage !== "") { setlangz = member.memberLanguage; }
				if(member.companyName !== undefined && member.companyName !== "undefined" && member.companyName !== "") { companyDomain = member.companyName; }

				var dataSendUser = {
					"doc_id": member.docid,
					"member_name": member.memberName,
					"member_email": member.memberEmail,
					"member_plan": member.memberPlan,
					"user_level": member.userLevel,
					"member_picture": picavatar,
					"member_language": setlangz,
					"uniq_token": member.uniqueToken,
					"member_company": companyDomain
				}
				this.generateSession(JSON.stringify(dataSendUser));
			}
		})
		.catch((err) => {
			alert(err);
			window.location.href = "/" + this.state.redirect;
		});
	}
	
	

	activate(docid,tabKey) {
		var dataText = '{"docid":"' + docid + '","form_id":"activation"}';
		var dataSend = JSON.parse(dataText);

		fetch(global.config.urlLink+"/activation", {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json",
				'Access-Control-Allow-Origin': "*",
				'Authorization': authKey
			},
			body: JSON.stringify(dataSend),
		})
		.then((result) => {
			if (result.status === 200) {
				return result.json();
			} else {
				console.log("Something happened wrong");
			}
		})
		.then((resultJson) => {
			if (resultJson.values[0].error) {
				if(resultJson.values[0].error ==="account is active") {
					document.getElementById("activation-success-message").style.display = "none";
					document.getElementById("activation-failed-message-1").style.display = "none";	
					document.getElementById("activation-failed-message-2").style.display = "flex";
					
				} else {
					document.getElementById("activation-success-message").style.display = "none";
					document.getElementById("activation-failed-message-1").style.display = "flex";	
					document.getElementById("activation-failed-message-2").style.display = "none";	
				}
			} else if (resultJson.values[0].docid) {
				document.getElementById("activation-success-message").style.display = "flex";
				document.getElementById("activation-failed-message-1").style.display = "none";	
				document.getElementById("activation-failed-message-2").style.display = "none";
			}
		});
	}
	  
	toggleForm(tab) {		
		window.location.href = "/" + tab;
  	}

	componentDidMount() {
		document.getElementsByClassName("err-area")[0].style.display = "none";
		if(localStorage.getItem('language') === undefined || localStorage.getItem('language') === "") {
			this.getLanguage();
		}
		this.setTab();
	}
	
	render() {
		return (
			<div className="Login">
				<TagHeaders value={
								{	
									docid: '', 
									title: 'Login', 
									description: '',
									links: global.config.urlHost+'/login'
								}
							}/>
				
				<Container>
					<div className="row justify-content-center p-5">
						<div className="col-lg-6 text-center">
						{ this.state.tab_form === 'login' && <h5 className="mb-3">{GetText() ? "Masuk ke" : "Login to"}</h5> }
							{ this.state.tab_form === 'register' && <h5 className="mb-3">{GetText() ? "Daftar ke" : "Register to"}</h5> }
							{ this.state.tab_form === 'forgot' && <h5 className="mb-3">{GetText() ? "Lupa Password" : "Forgot Password"}</h5> }
							{ this.state.tab_form === 'reset' && <h5 className="mb-3">{GetText() ? "Reset Password" : "Reset Password"}</h5> }
							{ this.state.tab_form === 'reset-expired' && <h5 className="mb-3">{GetText() ? "Reset Password" : "Reset Password"}</h5> }
							
							
							{/* { this.state.tab_form === 'register-success' && <h5 className="mb-3">{GetText() ? "Pendaftaran Berhasil" : "Register Success"}</h5> } */}
							{/* { this.state.tab_form === 'reset-success' && <h5 className="mb-3">{GetText() ? "Reset Password" : "Reset Password"}</h5> } */}
							{ this.state.tab_form === 'activation' && <h5 className="mb-3">{GetText() ? "Aktivasi Akun" : "Activation Account"}</h5> }
							{ this.state.tab_form === 'confirm-otp' && <h5 className="mb-3">{GetText() ? "Konfirmasi OTP" : "Confirm OTP"}</h5> }
							
							<h2 className="mb-5 text-primary text-800">NOVAIO ACADEMY</h2>
							<div className="err-area" style={{display: "none"}}>
								<div className="d-flex justify-content-center">
									<div><FaCircleInfo className="text-danger"/></div>
									<div className="ms-2 text-danger">{GetText() ? "tidak berhasil login" : "failed to login"}</div>
								</div>
							</div>

							{
								this.state.tab_form === 'login' && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<Form onSubmit={this.login}>
												<div className="mb-3">
													<label className="fw-bold form-label">{GetText() ? "Email" : "Email"}</label>
													{this.state.form_error.some(item => item === 'username') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
													<input className="form-control" type="text" name="username" value={this.state.username} onChange={this.inputUsername} autoComplete="username"/>
												</div>
												<div className="mb-3">
													<label className="fw-bold form-label">{GetText() ? "Password" : "Password"}</label>
													{this.state.form_error.some(item => item === 'password') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
													<input className="form-control" type="password" name="password" value={this.state.password} onChange={this.inputPassword} autoComplete="current-password"/>
												</div>
												<p className="text-link text-end mb-0" onClick={() => this.toggleForm('forgot')}>{GetText() ? "Lupa password?" : "Forgot password?"}</p>
												{this.state.form_error.some(item => item === 'invalid') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "Username atau password tidak ditemukan" : "Invalid username or password"}</p> : ''}
												<Button className="d-block mt-2 mb-4 mx-auto" variant="primary" size="lg" type="submit" value="Login" id="submit">{GetText() ? "Login" : "Login"}</Button>
											</Form>
											{
												GetText() ? (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('register')}>
													Belum memiliki akun? <span className="text-primary">Daftar</span>
													</p>
												) : (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('register')}>
														Not having an account yet? <span className="text-primary">Register</span>
													</p>
												)
											
											}
											<hr size="1" className="mt-4 mb-4"/>
											<p className="text-center mb-4">{GetText() ? "atau gunakan akun Google" : "or use Google account"}</p>
											<div className="d-flex align-items-center justify-content-center mb-4">
												<GoogleLogin 
												  type="standard"
												  theme="outline"
												  text="signin"
												  shape="rectangular"
												  onSuccess={this.successLogin}
												  onError={() => {
													console.log('Login Failed');
												  }}
												
												/> 
											</div>
											
										</Card.Body>
									</Card>
								)
							}
							{
								this.state.tab_form === 'register' && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<div id="register-page">
												<Form onSubmit={this.register}>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Nama Lengkap" : "Full Name"}</label>
														{this.state.form_error.some(item => item === 'fullname') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														{this.state.form_error.some(item => item === 'fullname_max') ? <span className="error-message">{GetText() ? 'Maksimal 80 karakter!' : 'Max 80 characters!'}</span> : ''}
														<input className="form-control" type="text" name="fullname" value={this.state.fullname} onChange={this.inputFullname}/>
													</div>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Email" : "Email"}</label>
														{this.state.form_error.some(item => item === 'email') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														<input className="form-control" type="email" name="email" value={this.state.email} onChange={this.inputEmail} autoComplete="username"/>
													</div>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Nomor HP" : "Phone Number"}</label>
														<input className="form-control" type="tel" name="phone" value={this.state.phone} onChange={this.inputPhone}/>
													</div>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Password" : "Password"}</label>
														{this.state.form_error.some(item => item === 'password') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														<input className="form-control" type="password" name="password" value={this.state.password} onChange={this.inputPassword} autoComplete="new-password"/>
													</div>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Konfirmasi Password" : "Confirm Password"}</label>
														{this.state.form_error.some(item => item === 'password_confirm') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														{this.state.form_error.some(item => item === 'password_same') ? <span className="error-message">{GetText() ? 'Password tidak cocok!' : 'Passwords don\'t match!'}</span> : ''}
														<input className="form-control" type="password" name="password_confirm" value={this.state.password_confirm} onChange={this.inputPasswordConfirm} autoComplete="confirm-password"/>
													</div>
													{this.state.form_error.some(item => item === 'inuse') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "Email sudah digunakan" : "Email already in use"}</p> : ''}
													<Button className="d-block mt-2 mb-4 mx-auto" variant="primary" size="lg" type="submit" value="Register" id="submit">{GetText() ? "Daftar" : "Register"}</Button>
												</Form>

												<p className="text-center mt-5 mb-4">{GetText() ? "atau daftar menggunakan akun Google" : "or register with Google account"}</p>
												<div className="d-flex align-items-center justify-content-center mb-4">
													<GoogleLogin 
													type="standard"
													theme="outline"
													text="signin"
													shape="rectangular"
													onSuccess={this.successLogin}
													onError={() => {
														console.log('Login Failed');
													}}
													
													/> 
												</div>
											</div>
											<div id="register-message" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaCircleCheck color="green" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Selamat!"  : "Congratulations!" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Akun Anda berhasil didaftarkan.<br/>Silakan cek email anda untuk melanjutkan</div>) 
														: ( <div  className="mt-4">Your account has been successfully registered.<br/>Please check your email to continue</div> ) 
													}
												</div>
											</div>
											{
												GetText() ? (
													<p className="text-link text-center mt-5" onClick={() => this.toggleForm('login')}>
													Sudah memiliki akun? <span className="text-primary">Login</span>
													</p>
												) : (
													<p className="text-link text-center mt-5" onClick={() => this.toggleForm('login')}>
														Already have an account? <span className="text-primary">Login</span>
													</p>
												)
											}
										</Card.Body>
									</Card>
								)
							}
							{
								(this.state.tab_form === 'forgot') && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<div id="forgot-page">
												<Form onSubmit={this.forgot}>
													<p className="mb-4">
														{	GetText() ? 
																"Masukkan email yang Anda gunakan untuk login. Instruksi untuk mengatur ulang password Anda akan dikirimkan ke email yang Anda masukkan" 
																: "Enter the email that you use to login. We'll send you an email with instructions to reset your password."
														}
													</p>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Email" : "Email"}</label>
														{this.state.form_error.some(item => item === 'email') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														<input className="form-control" type="text" name="email" value={this.state.email} onChange={this.inputEmail} autoComplete="username"/>
													</div>
													{this.state.form_error.some(item => item === 'invalid') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "Email tidak ditemukan" : "Invalid email"}</p> : ''}
													{this.state.form_error.some(item => item === 'account is deactive') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "Akun tidak aktif" : "Account is deactive"}</p> : ''}
													<Button className="d-block mt-2 mb-4 mx-auto" variant="primary" size="lg" type="submit" value="Forgot" id="submit">{GetText() ? "Kirim Link" : "Send Link"}</Button>
												</Form>
											</div>
											<div id="forgot-message" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaCircleCheck color="green" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Berhasil"  : "Success" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Permintaan reset password berhasil dikirim.<br/>Silakan cek email Anda untuk dapat mengatur ulang password</div>) 
														: ( <div  className="mt-4">Password reset request was sent successfully.<br/>Please check your email to reset the password</div> ) 
													}
												</div>
											</div>
											{
												GetText() ? (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('login')}>
														Kembali ke halaman <span className="text-primary">Login</span>
													</p>
												) : (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('login')}>
														Back to <span className="text-primary">Login</span> page
													</p>
												)
											}
										</Card.Body>
									</Card>
								)
							}
							
							{
								this.state.tab_form === 'reset' && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<div id="reset-page">
												<Form onSubmit={this.reset}>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Password Baru" : "New Password"}</label>
														{this.state.form_error.some(item => item === 'password') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														<input className="form-control" type="password" name="password" value={this.state.password} onChange={this.inputPassword} autoComplete="new-password"/>
													</div>
													<div className="mb-3">
														<label className="fw-bold form-label">{GetText() ? "Konfirmasi Password" : "Confirm Password"}</label>
														{this.state.form_error.some(item => item === 'password_confirm') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
														{this.state.form_error.some(item => item === 'password_same') ? <span className="error-message">{GetText() ? 'Password tidak cocok!' : 'Passwords don\'t match!'}</span> : ''}
														<input className="form-control" type="password" name="password_confirm" value={this.state.password_confirm} onChange={this.inputPasswordConfirm} autoComplete="confirm-password"/>
													</div>
													{this.state.form_error.some(item => item === 'invalid') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "Link tidak valid" : "Invalid Link"}</p> : ''}
													<Button className="d-block mt-2 mb-4 mx-auto" variant="primary" size="lg" type="submit" id="submit">{GetText() ? "Simpan" : "Save"}</Button>
												</Form>
											</div>
											<div id="reset-message" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaCircleCheck color="green" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Password berhasil diubah"  : "Password Changed" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Selamat! Password Anda telah berhasil diubah.<br/>Silakan <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> dengan menggunakan password baru Anda.</div>) 
														: ( <div  className="mt-4">Congratulations! Your password has been changed successfully.<br/>Please <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> using your new password.</div> ) 
													}
												</div>
											</div>
										</Card.Body>
									</Card>
								)
							}
							
							{
								this.state.tab_form === 'reset-expired' && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<div id="reset-expired-message" className="w-100">
												<div  className="text-center w-100">
													<div><FaTriangleExclamation color="#ffcc00" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Tautan Kadaluwarsa"  : "Expired Link" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Tautan reset password telah kadaluwarsa.<br/>Dapatkan tautan baru dengan mencoba <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/forgot'}>Lupa Password</span> lagi.</div>) 
														: ( <div  className="mt-4">The reset password link has been expired.<br/>Get a new link by trying the <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/forgot'}>Forgot Password</span> again.</div> ) 
													}
												</div>
											</div>
											
											{
												GetText() ? (
													<div className="mt-5">
														<p className="text-link text-center">atau</p>
														<p className="text-link text-center mt-2" onClick={() => this.toggleForm('login')}>
															Kembali ke halaman <span className="text-primary">Login</span>
														</p>
													</div>
												) : (
													<div className="mt-5">
														<p className="text-link text-center">or</p>
														<p className="text-link text-center mt-2" onClick={() => this.toggleForm('login')}>
															Back to <span className="text-primary">Login</span> page
														</p>
													</div>
												)
											}
										</Card.Body>
									</Card>
								)
							}
							{
								this.state.tab_form === 'activation' && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<div id="activation-success-message" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaCircleCheck color="green" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Aktivasi Berhasil"  : "Activation Success" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Selamat, akun anda sudah berhasil diaktifkan.<br/>Silakan <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> untuk melanjutkan.</div>) 
														: ( <div  className="mt-4">Congratulations, your account has been activated.<br/>Please <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> to continue.</div> ) 
													}
												</div>
											</div>
											<div id="activation-failed-message-1" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaTriangleExclamation color="#ffcc00" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Aktivasi Tidak Berhasil"  : "Activation Failed" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Link aktivasi ini tidak valid.<br/>Silakan klik tautan dari email Anda yang terdaftar.</div>) 
														: ( <div  className="mt-4">This activation link is invalid<br/>Please click the link from your registered email.</div> ) 
													}
												</div>
											</div>
											<div id="activation-failed-message-2" className="w-100" style={{display: "none"}}>
												<div  className="text-center w-100">
													<div><FaTriangleExclamation color="#ffcc00" fontSize="80px" /></div>
													<div className="mt-2 fs-3">{ GetText() ? "Aktivasi Tidak Berhasil"  : "Activation Failed" }</div>
													{	GetText() ? 
														( <div  className="mt-4">Akun anda sudah aktif.<br/>Silakan <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> untuk melanjutkan.</div>) 
														: ( <div  className="mt-4">Your account is active.<br/>Please <span className="text-primary" style={{cursor:"pointer"}} onClick={() => window.location.href = '/login'}>Login</span> to continue.</div> ) 
													}
												</div>
											</div>
										</Card.Body>
									</Card>
								)
							}
							
							{
								(this.state.tab_form === 'confirm-otp') && (
									<Card className="card-pop">
										<Card.Body className="text-start">
											<Form onSubmit={this.confirmOtp}>
												<div className="mb-3">
													<p className="text-center">{GetText() ? "Kami telah mengirimkan 6 digit kode OTP ke email Anda" : "We have sent a 6 digits OTP Code to your email"}</p>
													<label className="fw-bold form-label">{GetText() ? "Kode OTP" : "OTP Code"}</label>
													{this.state.form_error.some(item => item === 'otp') ? <span className="error-message">{GetText() ? 'Wajib diisi!' : 'Required!'}</span> : ''}
													<input className="form-control text-center" type="text" name="otp" value={this.state.otp} onChange={this.inputOtp} autoComplete="otp"/>
												</div>
												{this.state.form_error.some(item => item === 'invalid') ? <p className="error-message d-block mb-2 float-none text-center">{GetText() ? "OTP tidak ditemukan" : "Invalid OTP"}</p> : ''}
												<Button className="d-block mt-2 mb-4 mx-auto" variant="primary" size="lg" type="submit" value="Submit" id="submit">{GetText() ? "Kirim" : "Submit"}</Button>
											</Form>
											{
												GetText() ? (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('login')}>
														Kembali ke halaman <span className="text-primary">Login</span>
													</p>
												) : (
													<p className="text-link text-center mt-3" onClick={() => this.toggleForm('login')}>
														Back to <span className="text-primary">Login</span> page
													</p>
												)
											}
										</Card.Body>
									</Card>
								)
							}
							<div className="mt-5">
								<a className="text-light label-rounded bg-secondary" href="/privacy-policy">{GetText() ? "Kebijakan Pribadi" : "Privacy Policy"}</a>
							</div>
						</div>
					</div>
				</Container>
				
				<Modal animation={false} show={this.state.modal_show_refcode}>
					<Modal.Header>
						<Modal.Title>{GetText() ? "Kode Referral" : "Referral Code"}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form onSubmit={this.updateReferralCode}>
							<label className="mb-2">
								{/* {GetText() ? "Masukkan kode referral yang Anda miliki ke dalam kolom dibawah ini" : "Enter your referral code in the field below."} */}
								{GetText() ? "Apakah Anda memiliki kode referral?" : "Do you have a referral code"}
								<a className="text-dark text-link"
									data-tooltip-id="referral-tooltip"
									data-tooltip-content={GetText() ? "Dapatkan kode referral Anda di Tata Usaha sekolah Anda" : "Get your referral code in your school's Administration"}
									><FaRegCircleQuestion className="ms-2" /></a>
							</label>
							{this.state.form_error.some(item => item === 'referral_code') ? <p className="error-message">{GetText() ? "Kode belum dimasukkan" : "Code not inputted"}</p> : ''}
							{this.state.form_error.some(item => item === 'referral_code_2') ? <p className="error-message">{GetText() ? "Tidak valid" : "Invalid!"}</p> : ''}
							{this.state.form_error.some(item => item === 'referral_code_3') ? <p className="error-message">{GetText() ? "Anda Sudah Terdaftar" : "You've Already Registered!"}</p> : ''}

							<input className="form-control" type="text" 
								name="referral_code" 
								value={this.state.referral_code} 
								placeholder={GetText() ? "Masukkan kode referral anda disini" : "Enter your referral code here"}  
								onChange={this.inputReferralCode}
								ref={(input) => this.textInputReferralCode = input} 
							/>
							
							<Button className="mt-4" variant="secondary" size="md" type="submit" value="Submit" id="submit_refcode">{GetText() ? "Submit" : "Submit"}</Button>
							<Button className="ms-4 mt-4" variant="outline-secondary" size="md" type="button" value="Skip" id="skip_refcode" onClick={this.skipReferralCode.bind(this)}>{GetText() ? "Lanjutkan Tanpa Kode Referral" : "Continue Without Referral Code"}</Button>
						</Form>
						<Tooltip 
							id="referral-tooltip" 
							place="top-end" 
							border="1px solid #AAA"
							style={{ backgroundColor: "#EEE", color: "#222", width: "300px"}}
						/>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}
